import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import Slider from 'react-slick';
import { CarouselSettings } from '~/components/common/Carousel/types';
import Arrow from '~/icons/Arrow';

const Button = createComponent('button', {
  className: `flex
     h-48
     w-48
     items-center
     justify-center
     rounded-full
     border
     border-blue-700
     bg-white
     text-blue-700
     hover:bg-slate-200
     active:bg-blue-700
     active:!text-white
     xl:absolute
     xl:left-[calc(100%+24px)]`
});

type OwnProps = Partial<CarouselSettings> & {
  activeSlide: number;
  direction: 'left' | 'right';
  isAbsolute?: boolean;
  sliderRef: React.RefObject<Slider>;
};

export default function CarouselArrow({
  activeSlide,
  direction,
  eventBaseName,
  heading,
  isAbsolute,
  isNonVehicleCarousel,
  maxLength = 0,
  sectionName,
  slidesToShow = 4,
  sliderRef
}: OwnProps) {
  const isLeftArrow = direction === 'left';
  const leftDisabled = activeSlide === 0 && isLeftArrow;
  const rightDisabled =
    slidesToShow === maxLength ||
    (activeSlide + slidesToShow >= maxLength && !isLeftArrow);

  const handleClick = () => {
    if (isLeftArrow) {
      sliderRef.current?.slickPrev();
    } else {
      sliderRef.current?.slickNext();
    }
  };

  const analyticsAttributes = JSON.stringify({
    description: 'Carousel nav',
    sectionName: sectionName || heading,
    direction
  });
  const showArrow = maxLength > slidesToShow;

  return showArrow ? (
    <Button
      type="button"
      className={cx(
        isNonVehicleCarousel ? 'xl:top-[calc(50%-24px)]' : 'xl:top-[180px]',
        {
          'pointer-events-none disabled:cursor-not-allowed disabled:border-slate-300 disabled:bg-slate-100 disabled:fill-slate-300 disabled:text-slate-300':
            leftDisabled || rightDisabled,
          'xl:!left-[-72px]': isLeftArrow,
          'hidden xl:flex': isAbsolute
        }
      )}
      data-analytics-id={eventBaseName}
      data-analytics-attributes={analyticsAttributes}
      data-qa={`Carousel nav: ${isLeftArrow ? 'left' : 'right'}`}
      disabled={leftDisabled || rightDisabled}
      onClick={handleClick}
    >
      <Arrow
        className={cx('text-inherit relative w-24', {
          'rotate-180': isLeftArrow
        })}
      />
    </Button>
  ) : null;
}
